// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmtopbar-inline-1 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pmtopbar-inline-2 {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.pmtopbar-inline-3 {
  cursor: pointer;
}

.pmtopbar-inline-4 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMTopbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".pmtopbar-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pmtopbar-inline-2 {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.pmtopbar-inline-3 {\n  cursor: pointer;\n}\n\n.pmtopbar-inline-4 {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
